<iframe [src]="iframe|safe2: 'resourceUrl'" frameborder="0"></iframe>
